// La maquette produit sous le hero : le tableau de bord dans une fenêtre, et
// le téléphone verrouillé qui déborde devant. Tout est en HTML/CSS — pas une
// capture, donc toujours net, et les libellés sont ceux du vrai produit.
import { useT } from '../../lib/i18n'
import { Lock, Shield, Phone, Coin } from './Icons'

const BARS = [38, 52, 44, 70, 61, 88, 74, 56, 66, 100, 82, 71, 90, 48]

export function PhoneMock ({ className = '' }) {
  const m = useT().mock
  return (
    <div className={`lp-phone ${className}`.trim()} aria-hidden="true">
      <div className="lp-phone__scr">
        <span className="lp-phone__island" />
        <div className="lp-phone__status"><span>02:47</span><span className="lp-phone__sig"><i /><i /><i /></span></div>
        <div className="lp-phone__page">
          <span className="lp-phone__lockic"><Lock /></span>
          <span className="lp-phone__k">{m.phoneK}</span>
          <h3 className="lp-phone__t">{m.phoneT}</h3>
          <span className="lp-phone__host"><i /></span>
          <p className="lp-phone__s">{m.phoneS}</p>
        </div>
        <div className="lp-phone__foot">
          <b>{m.phoneDay}</b>
        </div>
      </div>
    </div>
  )
}

export default function ProductMock () {
  const m = useT().mock
  return (
    <div className="lp-mock" aria-hidden="true">
      <div className="lp-win">
        <div className="lp-win__bar">
          <span className="lp-win__dots"><i /><i /><i /></span>
          <span className="lp-win__url">app.selfcntrl.com/dashboard</span>
        </div>
        <div className="lp-win__body">
          <aside className="lp-win__side">
            <span className="lp-win__brand">{m.brand}</span>
            {m.nav.map((n, i) => (
              <span key={n} className={`lp-win__nav${i === 0 ? ' is-on' : ''}`}>{n}</span>
            ))}
          </aside>
          <div className="lp-win__main">
            <div className="lp-win__hero">
              <div>
                <span className="lp-win__days">{m.days}</span>
                <span className="lp-win__daysl">{m.daysL}</span>
                <span className="lp-win__since">{m.since}</span>
              </div>
              <div className="lp-win__lock">
                <span className="lp-win__lockic"><Shield /></span>
                <span><b>{m.lockT}</b><small>{m.lockS}</small></span>
              </div>
            </div>
            <div className="lp-win__grid">
              <div className="lp-win__card">
                <span className="lp-win__cardh">Devices</span>
                <ul className="lp-win__devs">
                  {m.devices.map(d => (
                    <li key={d.n}><Phone /><span><b>{d.n}</b><small>{d.s}</small></span><i className="lp-win__ok" /></li>
                  ))}
                </ul>
              </div>
              <div className="lp-win__card">
                <span className="lp-win__cardh">Requests blocked</span>
                <span className="lp-win__big">{m.blockedN}</span>
                <span className="lp-win__sub">{m.blockedL}</span>
                <div className="lp-win__bars">
                  {BARS.map((h, i) => <i key={i} style={{ height: `${h}%` }} className={i === BARS.length - 1 ? 'is-now' : ''} />)}
                </div>
              </div>
              <div className="lp-win__card lp-win__card--coin">
                <span className="lp-win__cardh"><Coin /> CNTRL</span>
                <span className="lp-win__big">640</span>
                <span className="lp-win__sub">360 to your next $5 card</span>
                <span className="lp-win__meter"><i style={{ width: '64%' }} /></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PhoneMock className="lp-mock__phone" />
    </div>
  )
}
